function trimLeftSlash (str: string) {
  return str.replace(/^\//, '');
}

export default function useApiUrl (relativeUri: string) {
  const config = useRuntimeConfig();
  return [config.public.proxyPrefix, 'public/learning-app', trimLeftSlash(relativeUri)].join('/');
}

// Endpoints that live at the `public/` root, outside the `learning-app/` namespace.
export function usePublicApiUrl (relativeUri: string) {
  const config = useRuntimeConfig();
  return [config.public.proxyPrefix, 'public', trimLeftSlash(relativeUri)].join('/');
}
